export default __webpack_public_path__ + "static/media/logo-fr.b6c0b63b.svg";